var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedSkate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 120.8,
    width: 25.8,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 97.7,
    width: 2.7,
    height: 25.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,33.4H37.8c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1h15l10.3,10.3h24.3c5.7,0,10.3-4.6,10.3-10.3 S93.1,33.4,87.4,33.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.5,
    cy: 34.6,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,113.1V78.7c0-1.4-0.5-2.6-1.4-3.6L48.5,46.5c-4,4-4,10.5,0,14.5l15.1,15.1l-28.1,28.2c-1,1-1.5,2.3-1.5,3.6 c0,1.3,0.5,2.6,1.5,3.6c1,1,2.3,1.5,3.6,1.5c1.3,0,2.6-0.5,3.6-1.5l25.5-25.5v27c0,1.4,0.6,2.7,1.5,3.6c0.9,0.9,2.2,1.5,3.6,1.5 s2.7-0.6,3.6-1.5C78,115.8,78.5,114.5,78.5,113.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedSkate);
export default __webpack_public_path__ + "static/media/speedSkate.402ce4db95560c69aab6e5944a0c55d3.svg";
export { ForwardRef as ReactComponent };